import React, { useState } from 'react';
import PageTemplate from '../../components/Common/PageTemplate';
import { useTranslation } from 'react-i18next';
import { FaTimes, FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const History = () => {
  const { t } = useTranslation();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [loadedImages, setLoadedImages] = useState({});

  const historicalPhotos = [
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03160520251106160904-1.jpg',
      caption: t('history.photos.1', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03160620251106160911-1.jpg',
      caption: t('history.photos.2', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03160720251106160921-1.jpg',
      caption: t('history.photos.3', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03160920251106160947-1.jpg',
      caption: t('history.photos.4', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161020251106160954-1.jpg',
      caption: t('history.photos.5', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161120251106161003-1.jpg',
      caption: t('history.photos.6', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161220251106161011-1.jpg',
      caption: t('history.photos.7', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161320251106161018-1.jpg',
      caption: t('history.photos.8', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161420251106161024-1.jpg',
      caption: t('history.photos.9', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161520251106161034-1.jpg',
      caption: t('history.photos.10', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161620251106161041-1.jpg',
      caption: t('history.photos.11', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161720251106161048-1.jpg',
      caption: t('history.photos.12', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    },
    {
      url: 'https://fs.hacettepe.edu.tr/fenyeni/resimler/tarihce/doc03161820251106161054-1.jpg',
      caption: t('history.photos.13', 'Hacettepe Üniversitesi - Tarihi Görünüm')
    }
  ];

  const handleImageLoad = (index) => {
    setLoadedImages(prev => ({ ...prev, [index]: true }));
  };

  const goToNext = () => {
    setSelectedImageIndex((prev) => (prev + 1) % historicalPhotos.length);
  };

  const goToPrevious = () => {
    setSelectedImageIndex((prev) => (prev - 1 + historicalPhotos.length) % historicalPhotos.length);
  };

  const handleKeyDown = (e) => {
    if (selectedImageIndex !== null) {
      if (e.key === 'ArrowRight') goToNext();
      if (e.key === 'ArrowLeft') goToPrevious();
      if (e.key === 'Escape') setSelectedImageIndex(null);
    }
  };

  React.useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImageIndex]);

  const timelineEvents = [
    {
      year: '1963',
      title: t('history.timeline.1.title'),
      description: t('history.timeline.1.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
        </svg>
      ),
    },
    {
      year: '1965',
      title: t('history.timeline.2.title'),
      description: t('history.timeline.2.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
    },
    {
      year: '1967',
      title: t('history.timeline.3.title'),
      description: t('history.timeline.3.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      ),
    },
    {
      year: '1968',
      title: t('history.timeline.4.title'),
      description: t('history.timeline.4.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      ),
    },
    {
      year: '1971',
      title: t('history.timeline.5.title'),
      description: t('history.timeline.5.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
    },
    {
      year: '1973',
      title: t('history.timeline.6.title'),
      description: t('history.timeline.6.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
    },
    {
      year: '1992',
      title: t('history.timeline.7.title'),
      description: t('history.timeline.7.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
        </svg>
      ),
    },
    {
      year: '2002',
      title: t('history.timeline.8.title'),
      description: t('history.timeline.8.description'),
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
        </svg>
      ),
    },
  ];

  return (
    <PageTemplate title={t('history.title')}>
      <div className="max-w-7xl mx-auto">
        {/* Üst Banner */}
        <div className="relative bg-gradient-to-r from-hacettepe-blue to-blue-800 rounded-xl shadow-2xl mb-12 overflow-hidden">
          <div className="absolute inset-0">
            <div className="absolute inset-0 bg-gradient-to-r from-hacettepe-blue to-blue-800 mix-blend-multiply" />
          </div>
          <div className="relative px-8 py-12 sm:px-12 sm:py-16">
            <h2 className="text-4xl font-extrabold text-white tracking-tight sm:text-5xl">
              {t('history.banner.title')}
            </h2>
            <p className="mt-6 max-w-3xl text-xl text-blue-100">
              {t('history.banner.subtitle')}
            </p>
          </div>
        </div>

        {/* Zaman Çizelgesi */}
        <div className="relative">
          {/* Orta Çizgi */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-hacettepe-blue"></div>

          <div className="space-y-12">
            {timelineEvents.map((event, index) => (
              <div key={event.year} className={`flex items-center ${index % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}>
                {/* Sol/Sağ İçerik */}
                <div className="w-1/2 pr-8 pl-8">
                  <div className="bg-white p-6 rounded-xl shadow-lg transform transition duration-500 hover:scale-105">
                    <div className="flex items-center mb-4">
                      <div className="bg-hacettepe-blue rounded-full p-2 text-white">
                        {event.icon}
                      </div>
                      <h3 className="ml-4 text-2xl font-bold text-gray-800">{event.year}</h3>
                    </div>
                    <h4 className="text-xl font-semibold text-hacettepe-blue mb-2">{event.title}</h4>
                    <p className="text-gray-600">{event.description}</p>
                  </div>
                </div>

                {/* Orta Nokta */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-hacettepe-blue rounded-full border-4 border-white shadow"></div>

                {/* Boş Alan */}
                <div className="w-1/2"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Alt Banner */}
        <div className="bg-gradient-to-br from-gray-900 to-hacettepe-blue rounded-xl shadow-lg overflow-hidden mt-12">
          <div className="px-8 py-12 sm:px-12">
            <div className="relative max-w-3xl mx-auto text-center">
              <h3 className="text-3xl font-bold text-white mb-6">
                {t('history.bottom_banner.title')}
              </h3>
              <p className="text-lg text-gray-300">
                {t('history.bottom_banner.subtitle')}
              </p>
            </div>
          </div>
        </div>

        {/* Tarihi Fotoğraflar Galerisi */}
        <div className="mt-16 mb-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {t('history.gallery.title', 'Geçmişten Günümüze')}
            </h2>
            <div className="w-24 h-1 bg-hacettepe-blue mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              {t('history.gallery.subtitle', 'Hacettepe Üniversitesi\'nin tarihi gelişimini fotoğraflarla keşfedin')}
            </p>
          </div>

          {/* Basit Grid Layout */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {historicalPhotos.map((photo, index) => (
              <div
                key={index}
                className="relative overflow-hidden rounded-lg shadow-md cursor-pointer bg-gray-200 aspect-[4/3]"
                onClick={() => setSelectedImageIndex(index)}
              >
                {!loadedImages[index] && (
                  <div className="absolute inset-0 bg-gray-300 animate-pulse" />
                )}
                <img
                  src={photo.url}
                  alt={photo.caption}
                  className="w-full h-full object-cover"
                  loading="eager"
                  onLoad={() => handleImageLoad(index)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImageIndex !== null && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/95"
          onClick={() => setSelectedImageIndex(null)}
        >
          {/* Close Button */}
          <button
            className="absolute top-4 right-4 text-white hover:text-gray-300 p-2 z-10"
            onClick={() => setSelectedImageIndex(null)}
          >
            <FaTimes className="w-8 h-8" />
          </button>

          {/* Previous Button */}
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 p-4 z-10"
            onClick={(e) => { e.stopPropagation(); goToPrevious(); }}
          >
            <FaChevronLeft className="w-8 h-8" />
          </button>

          {/* Next Button */}
          <button
            className="absolute right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 p-4 z-10"
            onClick={(e) => { e.stopPropagation(); goToNext(); }}
          >
            <FaChevronRight className="w-8 h-8" />
          </button>

          {/* Image */}
          <div className="max-w-7xl max-h-[90vh] px-16" onClick={(e) => e.stopPropagation()}>
            <img
              src={historicalPhotos[selectedImageIndex].url}
              alt={historicalPhotos[selectedImageIndex].caption}
              className="max-w-full max-h-[85vh] w-auto h-auto object-contain"
            />
            <p className="text-white text-center mt-4 text-lg">
              {historicalPhotos[selectedImageIndex].caption}
            </p>
            <p className="text-white/50 text-center mt-2 text-sm">
              {selectedImageIndex + 1} / {historicalPhotos.length}
            </p>
          </div>
        </div>
      )}
    </PageTemplate>
  );
};

export default History; 